import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({ providedIn: 'root' })
export class ResetService extends BaseService {
  constructor(
    client: HttpClient,
    configService: AppConfigService,
    authService: AuthService
  ) {
    super(client, configService, authService);
  }

  reset(email: string) {
    const forgotPasswordUrl = '/api/account/forgotpassword';
    const options = {
      headers: {
        'X-Allow-Anonymous': 'true',
      },
    };
    return this.post<string>(forgotPasswordUrl, { email }, options);
  }
}
